import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as moment from 'moment-timezone';

import { EnvironmentConfig } from '../../interfaces/environment.interface';
import {
  SubscribersResponse,
  SubscriberResponse,
  SubscriberPayload,
} from './subscriber.interface';

@Injectable({
  providedIn: 'root',
})
export class SubscriberService {
  private readonly _baseUrl =
    this._env.environment.pureSpectrum.reportServiceUrl;

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  public getTimeZones() {
    const timezones = [];
    for (let i = 0; i < moment.tz.names().length; i++) {
      let tzObj = {
        index: i,
        name:
          ' (GMT' +
          moment.tz(moment.tz.names()[i]).format('Z') +
          ') ' +
          moment.tz.names()[i],
        value: moment.tz.names()[i],
      };
      timezones.push(tzObj);
    }

    return timezones;
  }

  public getSubscribers(surveyId: number) {
    return this._http.get<SubscribersResponse>(
      `${this._baseUrl}/survey/${surveyId}/report/subscribers`
    );
  }

  public saveSubscriber(surveyId: number, payload: SubscriberPayload) {
    return this._http.post<SubscriberResponse>(
      `${this._baseUrl}/survey/${surveyId}/report/subscriber`,
      payload
    );
  }

  public deleteSubscriber(surveyId: number, email: string) {
    return this._http.delete<SubscriberResponse>(
      `${this._baseUrl}/survey/${surveyId}/report/subscriber`,
      { body: { email } }
    );
  }
}
